import React, { useContext, useEffect, useState } from "react";
import "./pastOrdersUi.scss";
import { Link, } from "react-router-dom";
import noImg from "../../Assets/images/no-image.jpg"
import StateContext from "../../StateContext";
import Chip from '@mui/material/Chip';
// global funtion for store
import { get_lang } from "../../../src/Functions/getLang";
// for Localization
import { withTranslation, useTranslation, Trans } from "react-i18next";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Avatar from '@mui/material/Avatar';
import {
  Button
} from "@material-ui/core/";


const PastOrderUi = (props) => {
  const { orderDetails, key } = props;
  const { t } = useTranslation();
  const appState = useContext(StateContext);
  const [orderPrice, setOrderPrice] = useState(0)
  useEffect(() => {
    let price = orderDetails.price;
    let sum_addons = orderDetails.sum_addons;
    let total = price + sum_addons;
    setOrderPrice(total)
    // console.log(orderDetails)
  }, [orderPrice]);


  return (
    <div id="pastOrdersUi" >
      <div className="col-12 px-0 prod_main_div py-1">
        <div className="col-12 px-0 inner_prod ">
          <Link to={`/dashboard/orders`}  className="prod_link">
            <div className="d-flex prod_content_row m-0">
              <div className="prod_categ_img px-0"
              >
             <Avatar variant="square"
                 src={orderDetails.business.logo ? `${orderDetails.business.logo}` : `${noImg}`}
                ></Avatar>
              </div>
              <div className="px-3 prod_content">
                <div className={` ${appState.langValue === "ar" ? "classForArabic" : ""
                  }`}>
                   <p style={{ overflow: 'hidden' }} className={`m-0 d-flex familyPoppins600  ${appState.langValue === "ar" ? "text-right" : "text-left"}`}>
                    <span>{`${orderDetails.business.currency != null ? orderDetails.business.currency : "Not Available"}`}</span>
                    <span className="px-1">{parseFloat(orderDetails.invoiceable.amount ? orderDetails.invoiceable.amount : "").toFixed(3)} &nbsp;</span>
                    <span className={` ${appState.langValue === "ar" ? "direction-ltr" : ""
                      }`} ><span className={`dot ${appState.langValue === "ar" ? "d-none" : ""
                    }`} >.</span>{orderDetails.created_at}</span>
                  </p>

                  <h4>
                    <strong className="d-flex textOver familyPoppins text-capitalize">
                      {`${orderDetails.business.name != null ? get_lang(orderDetails.business.name,appState.langValue) : "Not Available"}`}
                    </strong>
                  </h4>
                  {orderDetails.invoiceable.orders != [] ? orderDetails.invoiceable.orders.map((order, index) => {
                    return (
                      <h5 className={` familyPoppins ${appState.langValue === "ar" ? "d-flex text-right justify-content-end  direction-ltr " : ""
                        }`} key={index}>
                        <strong className="d-flex  text-capitalize">
                          <span className="px-1 ">{order.quantity}x {`${order.product != null ? get_lang(order.product.name, appState.langValue) : "Not Available"}`}</span>
                        </strong>
                      </h5>
                    )
                  }) : ""}
                  <div className={` familyPoppins ${appState.langValue === "ar" ? "d-flex justify-content-end  direction-ltr " : ""
                    }`}>
                   {orderDetails.status === "Pending" && <Chip icon={<TaskAltIcon />} className="pendingChip" label="Pending" variant="outlined" />}
                    {orderDetails.status === "ROS" && <Chip icon={<AccessTimeIcon />} className="orderdChip" label="Ordered" variant="outlined" />}
                    {orderDetails.status === "Direct" && <Chip icon={<AccessTimeIcon />} className="orderdChip" label="Ordered" variant="outlined" />}
                    {orderDetails.status === "Partial" && <Chip icon={<TaskAltIcon />} className="pendingChip" label="Pending" variant="outlined" />}
                    {orderDetails.status === "Processing" && <Chip label="Completed" className="completedChip" variant="outlined" />}
                    {orderDetails.status === "Rejected" && <Chip label="Canceled" className="cancelChip" variant="outlined" />}
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
      <hr />
    </div>

  );
};

export default withTranslation()(PastOrderUi);
